import React from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontIcon from 'material-ui/FontIcon';
import { connect } from '../../utils';


const FAButtonView = (props) => {
  const {id,layoutState} = props;
  const { buttonColors, mini, icon, href, buttonAlign , zDepth, disabled, containerPadding} = layoutState.getItemJS(id).props.values;
  
  return (
    <div style={{
      boxSizing: 'border-box',
      position: 'relative',
      height: 'auto',
      display: 'flex',
      width:'100%',
      justifyContent: buttonAlign,
      flex:1,
      padding: containerPadding
    }}>
      <FloatingActionButton
        disabled={disabled}
        disabledColor={buttonColors.disabledColor}
        mini={mini}
        zDepth={zDepth}
        backgroundColor={buttonColors.backgroundColor}
        href={href.url}
        target={href.target}
      >
        <FontIcon className="material-icons" style={{fill:buttonColors.color, color: buttonColors.color}} color={buttonColors.color} hoverColor={buttonColors.hoverColor}> {icon} </FontIcon>
      </FloatingActionButton>
    </div>
  );
}
 
export default connect('layoutState')(FAButtonView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/FAButtonView.js